import OfferWhiteSVG from './OfferWhiteSVG'
import { TypographyH2, TypographyP } from './typographyComponents'

export interface VillaBannerConfig {
  type: 'h2' | 'base'
  text: string
}

const defaultVillaBannerConfig: VillaBannerConfig[] = [
  {
    type: 'h2',
    text: 'Nu bjuder vi på räntekostnaden för handpenningslånet!',
  },
  {
    type: 'base',
    text: 'Erbjudandet gäller dig som tar bolån hos oss när du ska köpa en villa, och när du lånar till handpenningen innan 30 juni 2023.',
  },
  {
    type: 'base',
    text: 'Effektiv ränta: 0,00 %.',
  },
]

// The window.pcaConfig?.villaBannerConfig is feature toggleable
const villaBannerConfig = window.pcaConfig?.villaBannerConfig || defaultVillaBannerConfig

function ConfigItem({ type, text }: Readonly<VillaBannerConfig>) {
  if (type === 'h2') return <TypographyH2 type="banner">{text}</TypographyH2>
  return <TypographyP type="banner">{text}</TypographyP>
}

function VillaBanner() {
  return (
    <div className="mx-auto mt-8 flex max-w-[900px] flex-row bg-peach p-4 md:items-center md:py-0">
      <div className="-ml-3 -mt-12 hidden basis-1/4 justify-center min-[375px]:flex sm:ml-0 md:-mt-16">
        <OfferWhiteSVG />
      </div>
      <div className="pt-2 min-[375px]:basis-3/4">
        {villaBannerConfig.map((configItem, index) => (
          <ConfigItem key={index} {...configItem} />
        ))}
      </div>
    </div>
  )
}

export default VillaBanner
